import { Box, Button, ListItem, styled } from '@mui/material';
import { MenuItem as MuiMenuItem } from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import clsx from 'clsx';
import React from 'react';

const ITEM_HEIGHT = 30;

const StyledListItem = styled(ListItem)({
	display: 'flex',
	paddingTop: 0,
	paddingBottom: 0,
	height: ITEM_HEIGHT
});

const StyledButton = styled(Button, {
	shouldForwardProp: (prop) => !['isActive', 'depth'].includes(prop)
})(({ theme, isActive }) => ({
	borderRadius: 0,
	color: '#ffffff',
	justifyContent: 'flex-start',
	textTransform: 'none',
	letterSpacing: 0,
	width: '260px',
	height: ITEM_HEIGHT,
	...(isActive && {
		color: '#ffffff',
		borderRight: `4px solid ${theme.palette.primary.main}`,
		fontWeight: theme.typography.fontWeightBold,
		'& .MuiSvgIcon-root': {
			color: '#ffffff'
		}
	})
}));

const StyledIcon = styled(Box)({
	display: 'flex',
	alignItems: 'center',
	color: '#ffffff'
});

const StyledExpandIcon = styled(Box)({
	marginLeft: 'auto',
	height: 18,
	width: 18,
	display: 'flex',
	alignItems: 'center'
});

const StyledText = styled('span')(({ theme }) => ({
	marginLeft: theme.spacing(5)
}));

const MenuItem = ({
	handleClick,
	indent,
	active,
	value,
	depth = 0,
	open,
	expandable = false,
	text,
	icon: Icon
}) => {
	let paddingLeft = 18;

	if (depth > 0) {
		paddingLeft = 42 + 8 * depth;
	}

	const style = {
		paddingLeft
	};

	return (
		<StyledListItem disableGutters>
			<StyledButton
				onClick={(e) => handleClick(value, e)}
				isActive={active}
				style={style}
				color="primary"
			>
				{Icon && (
					<StyledIcon>
						<Icon />
					</StyledIcon>
				)}
				<StyledText>{text}</StyledText>
				{expandable && (
					<StyledExpandIcon>
						{open ? (
							<ExpandLess color="inherit" />
						) : (
							<ExpandMore color="inherit" />
						)}
					</StyledExpandIcon>
				)}
			</StyledButton>
		</StyledListItem>
	);
};

export default MenuItem;
